import { fetchRecentAirports } from 'actions/FlightActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'

interface Options {
  /**
   * Exclude this airport from the result
   */
  excludeAirport?: App.AirportLocation
}

function useRecentAirports(options: Options = {}) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchRecentAirports())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const recentAirports = useAppSelector(state => state.flights.recentAirports)

  return useMemo(() => {
    if (options.excludeAirport) {
      return recentAirports.filter(airport => airport.airportCode !== options.excludeAirport?.airportCode)
    }
    return recentAirports
  }, [recentAirports, options.excludeAirport])
}

export default useRecentAirports
